<template>
  <div
    class="blog-slider w-full"
  >
    <h2
      v-if="showTitle"
      class="font-open-sans text-xl lg:text-4xl sm:text-center text-EXPONDO-black"
    >
      {{ $t('Get inspired with expondo blog') }}
    </h2>
    <SimpleCarousel
      class="mt-6 lg:mt-20 lg:mb-24"
      :class="{ 'mb-8': !showPaginationControls }"
      :slider-items="posts"
      :per-page="5"
      :fixed-slide-width-value="337"
      :gap="20"
      :arrows="true"
      wrapper-classes="mx-auto"
      :breakpoints="blogSliderBreakpointsConfig"
      :show-pagination-controls="showPaginationControls"
    >
      <template #default="{ currentItem }">
        <BlogCard :post="currentItem" />
      </template>
    </SimpleCarousel>
  </div>
</template>
<script lang="ts">

import { SIMPLE_CAROUSEL_BREAKPOINTS } from '~~/constants/simpleCarousel';
import type { BlogCardItem } from '~~/types/blog/BlogCardItem';
export default defineComponent({
  name: 'BlogSlider',

  props: {
    posts: {
      type: Array as PropType<BlogCardItem[]>,
      default: () => [],
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showPaginationControls: {
      type: Boolean,
      default: false,
    },
  },
  setup () {

    const blogSliderBreakpointsConfig = {
      [SIMPLE_CAROUSEL_BREAKPOINTS.SM]: {
        perPage: 1.7,
      },
      [SIMPLE_CAROUSEL_BREAKPOINTS.MD]: {
        perPage: 3,
      },
      [SIMPLE_CAROUSEL_BREAKPOINTS.LG]: {
        perPage: 4,
      },
    };

    return {
      SIMPLE_CAROUSEL_BREAKPOINTS,
      blogSliderBreakpointsConfig,
    };
  
  },
});

</script>
<style lang="scss" scoped>
:deep(*) {
  .blog-slider {
    .simple-carousel {
      &-prev,
      &-next {
        @apply top-1/3;
      }

      &-prev {
        @apply -left-6;
      }

      &-next {
        @apply -right-6;
      }
    }
  }
}
</style>
